import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/users";

/**
 * Submits a standalone hardware order for the customer (PBI #308). The API resolves product
 * names and prices from the customer's assortment and mails the case to Diflex.
 *
 * @param {object} order - { source, tenantPublicId, billingGroupPublicId, items: [{ hardwareProductPublicId, quantity }], ... }
 * @param {string} apiAccessToken - Bearer token for the Insight API
 * @returns {Promise<{ caseReference: string }>} The case reference printed in the mail
 */
export async function submitHardwareOrder(order, apiAccessToken) {
  const response = await axios.post(`${baseUrl}/HardwareOrder/submit`, order, {
    headers: { Authorization: `Bearer ${apiAccessToken}` },
  });
  return response.data;
}
